// /forgot-password
import { API } from "../../apiSlice";

export const verifyOtpApiSlice = API.injectEndpoints({
  endpoints: (builder) => ({
    verifyOtp: builder.mutation({
      query: (data) => {
        return {
          url: `users/${data.endpoint}`,
          method: "POST",
          body: data,
        };
      },
    }),
  }),
});

export const { useVerifyOtpMutation } = verifyOtpApiSlice;
